// Filled at runtime from assets/encrypted-data.json (do not hard-code secrets here)
export const ENCRYPTED_DATA: any = {
    clientDecryptKey: '',
    secretKey: '',
    iv: '',
    ekycIv: '',
    ekycSecretKey: '',
  };